import {
  OrderDetailForCustomer as OrderDetail,
  OrderSummaryForCustomer as OrderSummary,
} from '~/generated/api-client/model';
import { DeliveryStatus, OrderStatus } from '~/models';

export const getOrderStatus = (orderDetail: OrderSummary | OrderDetail) => {
  return (
    orderDetail.order_completed_at
      ? 'completed'
      : orderDetail.tdmodels_delivered_at
      ? 'completed' // for backward-compatibility
      : orderDetail.inspection_requested_at
      ? 'inspection_requested'
      : orderDetail.scan_items_received_at
      ? 'processing'
      : orderDetail.payment_confirmed_at
      ? 'waiting_item'
      : orderDetail.order_placed_at
      ? 'waiting_payment'
      : orderDetail.quote_confirmed_at
      ? 'waiting_placement'
      : orderDetail.order_confirmed_at
      ? 'quote'
      : 'quote'
  ) as OrderStatus;
};

export const getDeliveryStatus = (orderDetail: OrderSummary | OrderDetail) => {
  return (
    orderDetail.scan_items_returned_at
      ? 'return'
      : orderDetail.scan_items_received_at
      ? 'processing'
      : 'waiting_item'
  ) as DeliveryStatus;
};

export const orderStatusToText = (status: OrderStatus) => {
  if (status === 'quote') return '見積もり中';
  if (status === 'waiting_placement') return '見積もり確認が必要です';
  if (status === 'waiting_payment') return 'お支払い待ち';
  if (status === 'waiting_item') return '商品受領待ち';
  if (status === 'processing') return '処理中';
  if (status === 'inspection_requested') return '検収中';
  if (status === 'completed') return '完了';
};

export const getQuoteInfo = (order: OrderDetail) => {
  const subtotal = order.items.reduce(
    (val, item) => val + (item.price?.amount ?? 0),
    0
  );
  const currency = order.items[0]?.price?.currency ?? '';
  const tax = currency === 'jpy' ? subtotal * 0.1 : 0;
  const total = subtotal + tax;
  return { currency, tax, subtotal, total };
};

export const orderRequiresCustomerAction = (orderStatus: OrderStatus) => {
  return [
    'waiting_placement',
    'waiting_payment',
    'waiting_item',
    'inspection_requested',
    'return',
  ].includes(orderStatus);
};
